import PubSub from "pubsub-js";
import roundTo from 'round-to';
import isUndefined from 'lodash.isundefined'

const getSensorReadings = (sensorId, dateRange, options = {}) => {

  return new Promise((resolve, reject) => {

    const datapoints = [
      {
        type: "float",
        datapoint: "temperature",
      },
      {
        type: "float",
        datapoint: "humidity",
      },
      {
        type: "float",
        datapoint: "tcTemp",
      },
      {
        type: "float",
        datapoint: "tcTemp2",
      },
      {
        type: "float",
        datapoint: "light",
      },
    ]

    // const readings = {
    //   temperature: {
    //     low: 0,
    //     high: 0,
    //     average: 0,
    //     values: []
    //   },
    //   humidity: {
    //     low: 0,
    //     high: 0,
    //     average: 0,
    //     values: []
    //   },
    // };

    const readings = {};

    datapoints.forEach(item => {
      readings[item.datapoint] = {
        low: 9999,
        high: -9999,
        average: 0,
        validCount: 0,
        values: [],
      }
    });

    const offset = new Date().getTimezoneOffset() * 60;
    let url = '';

    if(dateRange !== 'custom') {
      url = `/sensor/${sensorId}/readings?setting=${dateRange}&offset=${offset}`;
    } else {
      url = `/sensor/${sensorId}/readings?setting=${dateRange}&start=${encodeURIComponent(options.start)}&end=${encodeURIComponent(options.end)}&offset=${offset}`;
    }

    window.apiRequest('get',  url).then(r => {

      if(r.type === 'success') {

          if(r.data && r.data.readings.length > 0) {

            r.data.readings.forEach(message => {

              let datetime = window.datetimeToDate(message.sensor_time);

              datapoints.forEach(item => {

                let value = "n";
                let readingsForDatapoint = readings[item.datapoint];

                if (!isUndefined(message[item.datapoint])) {
                  if (message[item.datapoint] !== "n") {
                    if (item.type === 'float') {
                      value = parseFloat(message[item.datapoint]);

                      readingsForDatapoint.validCount += 1;
                      readingsForDatapoint.average += value;

                      if (readingsForDatapoint.low > value) {
                        readingsForDatapoint.low = value;
                      }

                      if (readingsForDatapoint.high < value) {
                        readingsForDatapoint.high = value;
                      }

                    }
                  }
                }

                readingsForDatapoint.values.push({
                  x: datetime,
                  y: value,
                  offline: message.offline,
                });

              });

            });

            datapoints.forEach(item => {

              if(readings[item.datapoint].validCount > 0) {
                if (item.type === 'float') {
                  readings[item.datapoint].average = roundTo(readings[item.datapoint].average / readings[item.datapoint].validCount, 1);
                }
              } else {

                readings[item.datapoint].high = "n";
                readings[item.datapoint].low = "n";
                readings[item.datapoint].average = "n";

              }

            });

            readings.start = r.data.start;
            readings.end = r.data.end;

            readings.raw = r.data.readings;

            // fire that loaded only if there are readings
            PubSub.publish('sensor/readings/loaded', {readings, dateRange, sensorId});

            resolve(readings);

          } else {
            resolve(false);
          }



      } else {
        resolve({
          error: true,
          message: r.message,
        });
      }

    });

  });

};

export default getSensorReadings;
